import React from 'react';
import {
  DownloadsHeader,
  WalletDownload,
  QRCodeDownload,
} from '../components';
import LinkNavigation from '@components/dashboard/links/verwaltung/LinkNavigation';

const Downloads = () => {
  return (
    <>
      <LinkNavigation />
      <DownloadsHeader />
      <WalletDownload />
      <QRCodeDownload />
    </>
  );
};

export default Downloads;
